export const newsRu = [
  {
    date: '26 мая 2022',
    text:
      'Бестселлер Ти Джей Ньюман «Падение» выходит в России эксклюзивно на Букмейте',
    link:
      'https://a.bmstatic.com/iu/53/67/BM_Falling_Press-release_RU-9f166738f04783d95e3f8a1c21d947a3.pdf',
    type: 'news',
  },
  {
    date: '12 апреля 2022',
    text:
      'Букмейт запускает марафон «Книги остаются»: читайте и слушайте бесплатно книги от 30 издательств',
    link:
      'https://a.bmstatic.com/iu/222/51/BM_Marathon_Press-release_RU-3a64d399ec52265781c0105b2eb759dd.pdf',
    type: 'news',
  },
  {
    date: '03 февраля 2022',
    text:
      'Bookmate Originals представляет мистический сериал Дарьи Бобылёвой с саундтреком группы «Хадн дадн»',
    link: 'https://mailchi.mp/4d9e070a43f2/darya_bobyleva_series',
    type: 'news',
  },
  {
    date: '08 декабря 2021',
    text:
      'Bookmate Originals представляет американский сериал «Ведьма, пришедшая с холода»',
    link: 'https://mailchi.mp/cadc1fbeb3a0/thewitchwhocameinfromthecold',
    type: 'news',
  },
  {
    date: '25 ноября 2021',
    text:
      'Дебютный роман Квентина Тарантино «Однажды в Голливуде» выходит в России эксклюзивно на Букмейте',
    link:
      'https://mailchi.mp/d8cbf4b438d4/tarantino-once-upon-a-time-in-hollywood',
    type: 'news',
  },
  {
    date: '22 ноября 2021',
    text:
      'К столетию Станислава Лема Bookmate Originals представляет сборник рассказов «Футуриада»',
    link: 'https://mailchi.mp/b2e12c3a3052/futuriada',
    type: 'news',
  },
  {
    date: '2 ноября 2021',
    text: 'Как в России слушают аудиокниги. Исследование Букмейта',
    link: 'https://mailchi.mp/049393496275/audiobooks',
    type: 'news',
  },
  {
    date: '6 мая 2021',
    text: 'Bookmate science hub – как читают в 21 веке',
    link: 'https://mailchi.mp/b7668e9e3a73/bookmate-science-hub',
    type: 'news',
  },
  {
    date: '12 ноября 2020',
    text: 'Букмейт запускает собственное производство аудиокниг',
    link: 'https://mailchi.mp/1bfbc15d45c5/owd8ffle22',
    type: 'news',
  },
  {
    date: '25 сентября 2020',
    text: '«Запрещенные барабанщики» и другие читают Лимонова',
    link:
      'https://a.bmstatic.com/iu/209/154/аудиокнигу_Эдуарда_Лимонова_«Старик путешествует»-df4c11277922a390305e22d28949fe9d.pdf',

    type: 'news',
  },
  {
    date: '11 сентября 2020',
    text:
      'Истории 11 сентября: Букмейт впервые публикует перевод масштабного проекта The New York Times на русском языке',
    link:
      'https://a.bmstatic.com/iu/9/100/Истории_11_сентября-1ba95ded8100a79da1f42c173d9e7323.pdf',
    type: 'news',
  },
  {
    date: '03 августа 2020',
    text: 'Хиросима – 75 лет первой в истории атомной бомбардировке',
    link:
      'https://a.bmstatic.com/iu/64/77/Хиросима-afa532bf306509e79b1822417b6ae9a8.pdf',
    type: 'news',
  },
  {
    date: '03 июля 2020',
    text:
      'Полная версия романа Бориса Акунина «Просто Маса» выходит на Букмейте 3 июля',
    link:
      'https://a.bmstatic.com/iu/72/134/роман_Борис_Акунин_«Просто Маса»-9131a4249f6e55744932325d824a5a60.pdf',
    type: 'news',
  },
  {
    date: '16 мая 2020',
    text: 'Театр.doc: 31 пьеса о событиях в России с 2002 по 2020 год',
    link:
      'https://a.bmstatic.com/iu/44/119/31_пьеса_Театра.doc-33c4619cd0f6105c7fe55da8c86b0c75.pdf',
    type: 'news',
  },
  {
    date: '15 мая 2020',
    text: 'Диван вместо метро: россияне стали читать больше. На 17% в день',
    link:
      'https://journal.bookmate.com/divan-vmesto-metro-my-stali-chitat-bolshe/',
    type: 'news',
  },
  {
    date: '10 апреля 2020',
    text:
      'Букмейт представляет сценарий Людмилы Улицкой «Чума» по мотивам событий 1939 года в Москве',
    link:
      'https://a.bmstatic.com/iu/17/207/Press-release_Ulitskaya-1206f15b38018e6228dacbba3dc8d388.pdf',
    type: 'news',
  },
  {
    date: '10 апреля 2020',
    text:
      'Букмейт представляет сценарий Людмилы Улицкой «Чума» по мотивам событий 1939 года в Москве',
    link:
      'https://a.bmstatic.com/iu/17/207/Press-release_Ulitskaya-1206f15b38018e6228dacbba3dc8d388.pdf',
    type: 'news',
  },
  {
    date: '30 марта 2020',
    text:
      'Букмейт представляет последнюю книгу Эдуарда Лимонова «Старик путешествует»',
    link:
      'https://a.bmstatic.com/iu/103/109/Bookmate_Limonov_last_book_2020-a1b667ee4feada2b1c2105a2ffb1b48a.pdf',
    type: 'news',
  },
  {
    date: '18 марта 2020',
    text: 'Букмейт открывает бесплатный доступ к книгам',
    link:
      'https://a.bmstatic.com/iu/83/239/Press-release_1-713d7a05531000cf3698ea445d30d4e9.pdf',
    type: 'news',
  },
  {
    date: '24 августа 2015',
    text: 'Букмейт приходит в Индонезию, крупнейший рынок в Юго-Восточной Азии',
    link:
      'https://a.bmstatic.com/iu/111/68/Press-release__Bookmate_prihodit_v_indoneziyu_krupneyshiy_rinok_v_yougo-vostochnoy_azii-0c395dafaddde0354088b707e9de56a8.pdf',
    type: 'news',
  },
  {
    date: '24 апреля 2015',
    text: 'Книжный сервис Букмейт пришëл в Беларусь',
    link:
      'https://a.bmstatic.com/iu/96/10/Knizhnyy_servis_Bookmate_prishel_v_Belarus-7554757695dfadee7c3d703b3985131e.pdf',
    type: 'news',
  },
  {
    date: '23 декабря 2014',
    text:
      'Российский книжный сервис Bookmate выходит на рынок Юго-Восточной Азии',
    link:
      'https://a.bmstatic.com/iu/161/131/Press_release__Rossiskiy_knizhnyy_servis_Bookmate_vyhodit_na_rynok_Jugo-Vostochnoi_Azii-29c2cbe26ecbdbe6efef589e7d989c52.pdf',
    type: 'news',
  },
  {
    date: '16 декабря 2014',
    text:
      'Bookmate познакомит студентов «Британки» и ВШЭ с современными практиками продвижения стартапов',
    link:
      'https://a.bmstatic.com/iu/187/211/Press_release__Bookmate_poznakomit_studentov_Britanki_i_VShJe_s_sovremennymi_praktikami_prodvizhenija_startapov-5c95f99926b539919bd1163a167b0891.pdf',
    type: 'news',
  },
  {
    date: '4 декабря 2014',
    text: 'Англоязычный каталог Bookmate превысил 200 тысяч книг',
    link:
      'https://a.bmstatic.com/iu/129/20/Press_release__Anglojazychnyy_katalog_Bookmate_prevysil_200_tysjach_knig-da72de64a22f89746802f734eec28cea.pdf',
    type: 'news',
  },
  {
    date: '27 ноября 2014',
    text: 'Воланд против Гарри Поттера, или что читает российский Facebook',
    link:
      'https://a.bmstatic.com/iu/4/240/Press_release__Voland_protiv_Garri_Pottera_ili_chto_chitaet_rossiyskiy_Facebook-9c580b2a0935d3e27ff162dbacd39e69.pdf',
    type: 'news',
  },
  {
    date: '24 ноября 2014',
    text:
      '«Обитель» Захара Прилепина лидирует по популярности у читателей среди номинантов «Большой книги»',
    link:
      "https://a.bmstatic.com/iu/234/1/Press_release__'Obitel'_Zahara_Prilepina_lidiruet_po_populjarnosti_u_chitateley_sredi_nominantov_'Bolshoy_knigi'-cf0fe86fc5cd32a6ea6efd0e6d58754d.pdf",
    type: 'news',
  },
  {
    date: '17 ноября 2014',
    text:
      'Bookmate стал самым популярным приложением для чтения в русскоязычном AppStore',
    link:
      'https://a.bmstatic.com/iu/31/135/Press_release__Bookmate_stal_samym_populjarnym_prilozheniem_dlja_chtenija_v_russkojazychnom_AppStore-e5e333009628ce5063145e30bc1f8643.pdf',
    type: 'news',
  },
  {
    date: '31 октября 2014',
    text:
      'В «Ночь искусств» москвичи получат бесплатную подписку на 500 тысяч электронных книг',
    link:
      "https://a.bmstatic.com/iu/164/33/Press_release__Uchastie_v_akcii_'Noch_iskusstv'-33b8f24bfdd20e8e51eec6c718295454.pdf",
    type: 'news',
  },
  {
    date: '8 октября 2014',
    text:
      'Крупнейшая в России англоязычная библиотека появилась в приложении Bookmate',
    link:
      'https://a.bmstatic.com/iu/231/172/Bookmate_pens_deal_with_HarperCollins_adding_English_language_ebooks_to_its_service_RU-630bfc08e2c5ec93f414c3301fcb1b30.pdf',
    type: 'news',
  },
  {
    date: '1 октября 2014',
    text:
      'Bookmate выпускает новое приложение для чтения на смартфонах и планшетах',
    link:
      'https://a.bmstatic.com/iu/100/47/Bookmate_launches_new_reading_app_for_iOS_and_Android_RU-ae01f7958400fe71aa2b0e45c9eec1f4.pdf',
    type: 'news',
  },
  {
    date: '16 июня 2014',
    text: 'Большая книга. Стартует читательское голосование',
    link:
      "https://a.bmstatic.com/iu/133/176/Public_voting_begins_in_2014_'The_Big_Book'_competition_RU-b07a279a98a1408af22209ef37001154.pdf",
    type: 'news',
  },
  {
    date: '29 мая 2014',
    text:
      'Дети, находящиеся на лечении в московских больницах, смогут записаться в «Мобильную библиотеку»',
    link:
      "https://a.bmstatic.com/iu/198/212/Children_treated_in_Moscow's_hospitals_to_get_access_to_library_of_electronic_books_RU-ffee941edd8be762e77f70c9c752ae0e.pdf",
    type: 'news',
  },
  {
    date: '20 апреля 2014',
    text: 'В Библионочь Bookmate станет бесплатным для всех',
    link:
      "https://a.bmstatic.com/iu/223/139/Bookmate_to_be_made_free_for_all_users_during_Russia's_annual_'Biblionoch'_event_RU-43c0ee873d6050643bb44657cca95e33.pdf",
    type: 'news',
  },
  {
    date: '7 апреля 2014',
    text:
      'Bookmate назван самым инновационным проектом Лондонской книжной ярмарки',
    link:
      'https://a.bmstatic.com/iu/143/152/Bookmate_named_best_innovation_at_the_London_Book_Fair_RU-d28ba0d6038dbc4ecd4d272081bd8835.pdf',
    type: 'news',
  },
  {
    date: '5 декабря 2014',
    text: 'Bookmate разработал приложение для чтения специально для YotaPhone',
    link:
      'https://a.bmstatic.com/iu/160/134/Bookmate_has_designed_an_e_reading_app_optimised_to_work_on_new_YotaPhone_RU-8cfda16d8208ffd00c468d83bcad1a94.pdf',
    type: 'news',
  },
]

export const newsEn = [
  {
    date: 'June 6, 2022',
    text: 'Bookmate is expanding into Croatia',
    link:
      'https://a.bmstatic.com/iu/145/178/Press-release_Bookmate_in_Croatia_eng_6jun-a3dc744670a1e4d632212866a406c741.pdf',
    type: 'news',
  },
  {
    date: 'October 30, 2017',
    text: 'Bookmate Launches In Balkans',
    link:
      'https://a.bmstatic.com/iu/209/205/Bookmate_Launches_In_Balkans_EN-7e39ee98cffe86148fe7ffbb7f56f075.pdf',
    type: 'news',
  },
  {
    date: 'January 26, 2017',
    text:
      'Bookmate Announces TELMORE Partnership, Brings e-reading Service to Denmark',
    link:
      'https://a.bmstatic.com/iu/221/254/Bookmate_announces_TELMORE_partnership_EN-984ffb69da44e9c984bf803dbb0bb7cb.pdf',
    type: 'news',
  },
  {
    date: 'August 25, 2015',
    text: 'Bookmate moves into Indonesia with Indosat',
    link:
      'https://a.bmstatic.com/iu/237/201/Bookmate_moves_into_Indonesia_with_Indosat-4e574a5c099cf297dc530f30e12972bb.pdf',
    type: 'news',
  },
  {
    date: 'December 17, 2014',
    text: 'Bookmate continues international expansion with StarHub partnership',
    link:
      'https://a.bmstatic.com/iu/136/236/Bookmate_Continues_International_Expansion_with_StarHub_Partnership-1f7fb2f8dd143b6a6f1b653b073eb6ef.pdf',
    type: 'news',
  },
  {
    date: 'October 8, 2014',
    text:
      'Bookmate pens deal with HarperCollins adding English language ebooks to its service',
    link:
      'https://a.bmstatic.com/iu/77/8/Bookmate_pens_deal_with_HarperCollins_adding_English_language_ebooks_to_its_service_EN-6bd4d9b7cf5c6a36a56c8d36ef437d0a.pdf',
    type: 'news',
  },
  {
    date: 'September 30, 2014',
    text: 'Bookmate launches new reading app for iOS and Android',
    link:
      'https://a.bmstatic.com/iu/202/138/Bookmate_launches_new_reading_app_for_iOS_and_Android_EN-d00863ab4b9b740708d49aaefb3fa958.pdf',
    type: 'news',
  },
  {
    date: 'April, 7, 2014',
    text: 'Bookmate named best innovation at the London Book Fair',
    link:
      'https://a.bmstatic.com/iu/245/243/Bookmate_named_best_innovation_at_the_London_Book_Fair_EN-e60f8235ce4f8e93e162e2c4ddffa8da.pdf',
    type: 'news',
  },
]

const newsHr = [
  {
    date: 'June 6, 2022',
    text: 'E-knjige i audio-knjige stižu u Hrvatsku',
    link:
      'https://a.bmstatic.com/iu/194/169/Press-release_Bookmate_in_Croatia_CR_6jun-10f0d85d8a267c790e1806712354bb35.pdf',
    type: 'news',
  },
  ...newsEn.slice(1),
]

const newsDa = [
  {
    date: 'July 1, 2022',
    text: 'Bookmate er nu gratis tilgængelig for pendlere hos Arriva',
    link:
      'https://a.bmstatic.com/iu/158/124/Press-release_Arriva_1jul-d8087a96c267a94be57f29ab22fe38f2.pdf',
    type: 'news',
  },
  ...newsEn,
]

export type NewsType = {
  date: string
  text: string
  link: string
  type: string
}

export const getNews = (locale: string): NewsType[] => {
  switch (locale) {
    case 'ru':
      return newsRu
    case 'hr':
      return newsHr
    case 'da':
      return newsDa
    default:
      return newsEn
  }
}
